import { ManifestDefinitions } from '../types';
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from '../errors';

// TODO: remove once manifest will be updated with default values
const defaultEditingBehaviors = {
  selectable: true,
  removable: true,
  duplicable: true,
  rotatable: true,
  pinnable: true,
  anchorable: true,
  moveAxis: 'ALL',
  stretch: 'FULL',
  overflowOptions: undefined
};
function getPresets(_ref) {
  let {
    manifest
  } = _ref;
  const presetsEntries = Object.entries((manifest == null ? void 0 : manifest.presets) ?? {});
  if (!presetsEntries.length) {
    return null;
  }
  return presetsEntries.map(_ref2 => {
    let [key, value] = _ref2;
    return {
      id: key,
      name: value.displayName,
      src: value.imgUrl ?? ''
    };
  });
}
function getStyleDefinition(_ref3) {
  var _manifest$definitions;
  let {
    manifest
  } = _ref3;
  return (manifest == null || (_manifest$definitions = manifest.definitions) == null ? void 0 : _manifest$definitions.style) ?? null;
}
function getDisplayName(_ref4) {
  let {
    manifest
  } = _ref4;
  return (manifest == null ? void 0 : manifest.displayName) ?? null;
}
function getBehaviorsValue(_ref5) {
  var _manifest$definitions2;
  let {
    property,
    manifest
  } = _ref5;
  return (manifest == null || (_manifest$definitions2 = manifest.definitions) == null || (_manifest$definitions2 = _manifest$definitions2.editingBehaviors) == null ? void 0 : _manifest$definitions2[property]) ?? defaultEditingBehaviors[property];
}
function getCompType(_ref6) {
  let {
    manifest
  } = _ref6;
  return (manifest == null ? void 0 : manifest.compType) ?? '';
}
function getRootManifestData(_ref7) {
  let {
    manifest,
    property
  } = _ref7;
  const handlers = {
    presets: getPresets,
    displayName: getDisplayName
  };
  const handler = handlers[property];
  if (!handler) {
    throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.NoSuchHandlerToGetManifestData, property);
  }
  return handler({
    manifest
  });
}
const getManifestValueHandlers = {
  [ManifestDefinitions.behaviors]: getBehaviorsValue,
  [ManifestDefinitions.style]: getStyleDefinition,
  [ManifestDefinitions.rootManifestData]: getRootManifestData,
  [ManifestDefinitions.compType]: getCompType
};
export { getManifestValueHandlers, defaultEditingBehaviors };
//# sourceMappingURL=getManifestValueHandlers.js.map